<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Thêm mới ảnh vào cấu hình hiển thị</strong>
          </div>
          <b-form @submit.prevent="save">
            <b-row>
              <b-col>
                <b-form-group
                  label="Tên:"
                  label-for="title"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  label-class="required"
                >
                  <b-form-input
                    type="text"
                    id="title"
                    class="col-10"
                    v-model="$v.configDisplay.name.$model"
                    :state="
                      $v.configDisplay.name.$dirty
                        ? !$v.configDisplay.name.$error
                        : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Trường này không được để trống!
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Các danh mục hiển thị:"
                  label-align="right"
                  label-for="description"
                  :label-cols="2"
                  :horizontal="true"
                >
                  <treeselect
                    class="col-10 no-padding"
                    id="categoryId"
                    :multiple="true"
                    v-if="categories.length > 0"
                    v-model="configDisplay.categoryIds"
                    placeholder="--- Chọn ---"
                    :options="categories"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Số phần tử hiển thị:"
                  label-align="right"
                  label-for="description"
                  :label-cols="2"
                  :horizontal="true"
                >
                  <b-form-input
                    type="number"
                    class="col-10"
                    v-model="configDisplay.numberShow"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Số thứ tự hiển thị:"
                  label-align="right"
                  label-for="description"
                  :label-cols="2"
                  :horizontal="true"
                >
                  <b-form-input
                    type="number"
                    class="col-10"
                    v-model="configDisplay.orderDisplay"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group :label-cols="2" :horizontal="true">
                  <b-button
                    v-if="authorize(['ManageConfigDisplay'])"
                    type="submit"
                    variant="primary"
                    >Ghi lại</b-button
                  >
                  <b-button type="button" variant="secondary" @click="cancel">
                    Hủy</b-button
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { authorizationMixin } from "@/shared/mixins";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  name: "CreateConfigDisplay",
  mixins: [validationMixin, authorizationMixin],
  data() {
    return {
      configDisplay: {
        id: 0,
        name: null,
        numberShow: null,
        orderDisplay: null,
        categoryIds: [],
      },
    };
  },
  validations: {
    configDisplay: {
      name: { required },
    },
  },
  created() {},
  computed: {
    ...mapState({
      categories: (state, getters) => getters.categoryTree,
    }),
  },
  methods: {
    cancel() {
      this.$router.push({ path: "." });
    },
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var vm = this;
        this.$services
          .post("system/config-display", this.configDisplay)
          .done(() => {
            vm.$toastr.s("Thêm mới cấu hình thành công!");
            vm.$router.push({ path: "." });
          });
      }
    },
  },
};
</script>
<style scoped>
</style>
